import React, { useState, useEffect } from "react";
import {
    Accordion,
    Button,
    Card,
    Col,
    Collapse,
    Modal,
    OverlayTrigger,
    Row,
    Spinner,
    Table,
    Tooltip,
} from "react-bootstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Link, useNavigate } from "react-router-dom";

// import avatar1 from "../../../images/avatar/1.jpg";
import avatar1 from "../../images/avatar/1.jpg";
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import AddUserByAdmin from "../addUserByAdmin/addUserByAdmin";
import ParticularUserDetailsForAdmin from "../particularUserDetailsForAdmin/particularUserDetailsForAdmin";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { registeredUser } from "../../service/api/user/registeredUser";
import { useDispatch, useSelector } from "react-redux";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import deleteUser from "../../service/api/user/deleteUserById";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import { lblEmail, lblPhoneNumber, txtAction, txtCreatedDate, txtDashboard, txtDeleteAccountConfirmation, txtLastLogin, txtName, txtNoRecordsFound, txtRole } from "../../dataBaseFile/label";
import { btnAddUser, btnCheckWaitingUsers, btnFeedback } from "../../dataBaseFile/alert";
import verifyUserApi from "../../service/api/user/verifyUser";
import { FaSearch, FaUserCog } from "react-icons/fa";
import { setCurrentPage, setImpersonateAccessToken, setImpersonateFlag, setImpersonateRefreshToken, setImpersonateRoleId, setImpersonateUserId, setUserDetails } from "../../feature/userData/userData";
import { userById } from "../../service/api/user/userById";
import { LuArrowUpDown } from "react-icons/lu";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement"
import { getPaymentTransactionListApi } from "../../service/api/paymentGateway/getPaymentTransactionList";
import SelectPeriodFilter from "../../jsx/components/fields/selectPeriodFilter";
const TransactionsForAdmin = () => {
    const nevigate = useNavigate();
    const { role, permissionArr, impersonateFlag } = useSelector((state) => state.user);
    const permissionArray = permissionArr[0] || []
    const [basicModal, setBasicModal] = useState(false);
    const [initiColor, setInitiColor] = useState(true);
    const [sortingCol, setSortingCol] = useState(true);

    const [skeltonVal, setSkeltonVal] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [elements, setElements] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [deletingId, setDeletingId] = useState(false);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [columnName, setColumnName] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [flag, setFlag] = useState(false);
    const [handleToaster, setHandleToaster] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [resMessage, setResMessage] = useState("");
    const [firstCheck, setFirstCheck] = useState(false);
    const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);
    const [userVerified, setUserVerified] = useState(0)
    const [impersonateModal, setImpersonateModal] = useState(false)
    const [impersonateId, setImpersonateId] = useState()

    const [filtreBox, setFiltreBox] = useState(false);
    const [filtreValue, SetFiltreValue] = useState(1);

    const [isExpandedTransactionId, setIsExpandedTransactionId] = useState('');

    const [periodFilter, setPeriodFilter] = useState('');
    const periodArr = [
        { id: "WEEK", name: "Last week" },
        { id: "MONTH", name: "Last month" },
        { id: "QUARTER", name: "Last quarter" },
        { id: "YEAR", name: "Last year" },
        { id: "ALL", name: "ALL" },
    ]
    const handlePeriodFilter = (e) => {
        setPeriodFilter(e.target.value);
    }

    const percentage = 70;

    const tooltipDelete = (
        <Tooltip id="tooltip">
            <strong>Delete</strong>
        </Tooltip>
    );
    const tooltipEdit = (
        <Tooltip id="tooltip">
            <strong>Edit</strong>
        </Tooltip>
    );
    const tooltipVerify = (
        <Tooltip id="tooltip">
            <strong>Verify</strong>
        </Tooltip>
    );

    useEffect(() => {
        dispatch(setCurrentPage("Admin"));
    }, []);


    // With new logic
    const [expandedRow, setExpandedRow] = useState(null);

    const handleToggle = (rowIndex) => {
        if (rowIndex === expandedRow) {
            setExpandedRow(null);
        } else {
            setExpandedRow(rowIndex);
        }
    }




    // Dummy call check for toaster

    const getCallHistoryDetails = (res) => {

        // const newElements = [...elements, ...res.data];
        // const uniqueElements = Array.from(
        //   new Set(newElements.map(JSON.stringify))
        // ).map(JSON.parse);


        setElements(res.data);
        setTotalNoRecord(res.total_count);


        if (res.total_count % pageSize === 0) {
            setTotalPage(parseInt(res.total_count / pageSize));
        } else {
            setTotalPage(parseInt(res.total_count / pageSize + 1));
        }

    };

    function onLoadData() {

        setSkeltonVal(true);
        setCustomeSkeletonLoading(true);

        const data = new FormData();
        // data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("status_chr", 'all')
        data.append("current_date", Math.floor(Date.now() / 1000))
        data.append("filter_type", periodFilter === 'ALL' ? '' : periodFilter)
        data.append("page_index", page);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);

        dispatch(
            //   registeredUser(data, (res) => {
            getPaymentTransactionListApi(data, (res) => {
                setSkeltonVal(false);
                setElements(res.data.data);
                getCallHistoryDetails(res.data);
                setCustomeSkeletonLoading(false);
                setTotalNoRecord(res.data.total_count);
                if (res.data.total_count % pageSize === 0) {
                    setTotalPage(parseInt(res.data.total_count / pageSize));
                } else {
                    setTotalPage(parseInt(res.data.total_count / pageSize + 1));
                }

            }, (err) => {
                setCustomeSkeletonLoading(true);
            })
        );

        return;
    }

    const handleColumnName = (name) => {
        setSortingCol(false);
        setColumnName(name);

        if (sortByValue === "ASC") {
            setSortByValue("DESC");
        }
        if (sortByValue === "DESC") {
            setSortByValue("ASC");
        }
    };

    const handleOrderValue = (order) => {
        setSortByValue(order);
    };

    const handleSearch = (e) => {
        setPage(1);
        const ele = []
        setElements(ele);
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
            setColumnName('')
        }
        setSearchValue(e.target.value)
    };

    const handleChangeRowsPerPage = (e) => {
        // console.log(e)
        setSearchValue("");
        setPage(1);
        setPageSize(e.target.value);
    };

    const onChangePage = (e, p) => {
        // setPage(p);
        setPage(e);
    };

    useEffect(() => {
        onLoadData();
    }, [sortByValue, pageSize, page, columnName, filtreValue, periodFilter]);

    useEffect(() => {
        // if (searchValue.trim().length > 2) {
        //   const ele = [];
        //   setPage(1);
        //   setElements(ele);
        //   setFlag(true);
        //   const timeOutId = setTimeout(onLoadSearch, 1000);
        //   return () => clearTimeout(timeOutId);
        // } else if (searchValue.trim().length === 0 || searchValue.trim() == "") {
        //   if (flag) {
        //     onLoadData();
        //   }
        // }

        if (searchValue.trim().length > 2) {
            setFlag(true);
            const timeOutId = setTimeout(onLoadSearch, 1000);
            return () => clearTimeout(timeOutId);
        } else if (searchValue.trim().length === 0) {
            if (flag) {
                onLoadSearch();
            }
        }
    }, [searchValue]);

    function onLoadSearch() {
        setSkeltonVal(true);
        // var data = {
        //     // user_id_ids: localStorage.getItem("user_id"),
        //     page_index: 1,
        //     page_size: pageSize,
        //     sorting_order: sortByValue,
        //     sorting_column_name: "",
        //     search_area: searchValue,
        // };

        const data = new FormData();
        // data.append("user_id_ids", localStorage.getItem("user_id"));
        data.append("status_chr", 'all')
        data.append("current_date", Math.floor(Date.now() / 1000))
        data.append("filter_type", periodFilter === 'ALL' ? '' : periodFilter)
        data.append("page_index", 1);
        data.append("page_size", pageSize);
        data.append("sorting_order", sortByValue);
        data.append("sorting_column_name", columnName);
        data.append("search_area", searchValue);
        dispatch(
            getPaymentTransactionListApi(data, (res) => {
                setSkeltonVal(false);
                getCallHistoryDetails(res.data);
                // setElements(res.data.data);
                // setTotalNoRecord(res.data.total_count);
                // if (res.data.total_count % pageSize === 0) {
                //   setTotalPage(parseInt(res.data.total_count / pageSize));
                // } else {
                //   setTotalPage(parseInt(res.data.total_count / pageSize + 1));
                // }

            })
        );
    }

    function handleSetFiltreValue(v) {
        SetFiltreValue(v);
        const ele = [];
        setPage(1);
        setElements(ele);
        if (v === 1) {
            setSortByValue("DESC");
        } else if (v === 2) {
            setSortByValue("ASC");
        }
    }

    function handleOpenFiltreBox() {
        setFiltreBox(!filtreBox);
    }

    const searchAreaVal = (e) => {
        // setSearchArea(e.target.value)
        // if (searchArea.trim().length >= 2) {
        //     onChangePage(1)
        // }

        setSearchValue(e.target.value)
        if (searchValue.trim().length >= 2) {
            onChangePage(1)
        }
    }

    // Format the unix time in given format
    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString('default', { month: 'short' });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? 'am' : 'pm';
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    return (
        <>
            {/* New Admin dashboard */}
            <div className="row mx-3 mb-5" style={{}}>
                <div className="col-12 px-0">

                    <div className="row mx-0 p-3">
                        <div className="col-12 px-0 d-flex align-item-center justify-content-start">
                            <span className="fs-4 fw-bold text-black">{"Transactions"}</span>
                        </div>
                    </div>

                    <div className="mt-3 d-flex justify-content-end">
                        <div style={{ width: '250px' }}>
                            <SelectPeriodFilter
                                labelName={`Period`}
                                onChange={(e) => handlePeriodFilter(e)}
                                defaultValue={periodFilter}
                                options={periodArr}
                                errorOccured={false}
                                errorMessage={""}
                            />
                        </div>
                    </div>

                    <div className='my-3'>
                        <PaginationAndSearching
                            handleSearch={searchAreaVal}
                            // searchValue={searchArea}
                            searchValue={searchValue}
                            defaultValue={pageSize}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            totalCount={totalPage}
                            onChange={onChangePage}
                        />
                    </div>


                    <Table responsive>

                        <thead>
                            <tr className='text-black bg-light'>
                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("created_date_dtm") }}
                                >
                                    {`Created on`}
                                    <span className="ml-1">
                                        {columnName === 'created_date_dtm' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>

                                <th
                                    // className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                // onClick={() => { handleColumnName("display_id_int") }}
                                >
                                    {`Service Id`}
                                    {/* <span className="ml-1">
                                        {columnName === 'display_id_int' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span> */}
                                </th>


                                {false && <>
                                    <th
                                        // className='cursor-pointer'
                                        style={{ fontWeight: '700' }}
                                    // onClick={() => { handleColumnName("first_name_chr") }}
                                    >
                                        {`Description`}
                                        {/* <span className="ml-1">
                                        {columnName === 'first_name_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span> */}
                                    </th>
                                </>}


                                <th
                                    // className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                // onClick={() => { handleColumnName("email_chr") }}
                                >
                                    {`Amount`}
                                    {/* <span className="ml-1">
                                        {columnName === 'email_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span> */}
                                </th>




                                <th
                                    className='cursor-pointer'
                                    style={{ fontWeight: '700' }}
                                    onClick={() => { handleColumnName("status_chr") }}
                                >
                                    {`Status`}
                                    <span className="ml-1">
                                        {columnName === 'status_chr' ? (
                                            <>
                                                {sortByValue === "DESC" && <i className="fa fa-arrow-down ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("ASC") }} />}

                                                {sortByValue === "ASC" && <i className="fa fa-arrow-up ms-2 fs-14" style={{ opacity: '0.7' }} onClick={() => { handleOrderValue("DESC") }} />}

                                            </>
                                        )
                                            :
                                            (<i className="fa fa-sort ms-2 fs-14" style={{ opacity: '0.3' }} />)
                                        }
                                    </span>
                                </th>

                            </tr>
                        </thead>

                        <tbody>
                            {customeSkeletonLoading ?
                                <SkeletonTableRow cols={4} /> :
                                <>
                                    {elements?.length > 0 ?
                                        <>
                                            {elements?.map((element, index) => {
                                                return (
                                                    <>
                                                        <tr
                                                            className={`notification-rows font-w700 ${isExpandedTransactionId === element.call_log_transactions_id_ids ? "bg-primary text-white " : ""}`}
                                                            key={index}
                                                            style={{ cursor: 'default' }}
                                                        // onClick={() => {
                                                        //     if (element?.call_log_transactions_id_ids === isExpandedTransactionId) {
                                                        //         setIsExpandedTransactionId('')
                                                        //     } else {
                                                        //         setIsExpandedTransactionId(element.call_log_transactions_id_ids)
                                                        //     }
                                                        // }}
                                                        >

                                                            <td>
                                                                {/* <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span> */}

                                                                <span className="">{`${element?.created_date_dtm ?
                                                                    new Intl.DateTimeFormat("en-US", {
                                                                        year: "numeric",
                                                                        month: "short",
                                                                        day: "numeric",
                                                                        hour: 'numeric',
                                                                        minute: 'numeric',
                                                                        hour12: true
                                                                    }).format(
                                                                        element?.created_date_dtm * 1000
                                                                    ) : '-'}`}</span>
                                                            </td>

                                                            <td>
                                                                <span className="">{`${element?.display_id_int ? `#${element?.display_id_int}` : '-'}`}</span>
                                                            </td>

                                                            {/* <td>
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        // src={profilePicture}
                                                                        src={element?.preferred_profile_picture_url}
                                                                        className={`rounded-lg me-2 ${element?.user_id_ids === isExpandedTransactionId ? "border" : ""} rounded-3`}
                                                                        width="24"
                                                                        height="24"
                                                                        alt=""
                                                                        style={{ objectFit: "contain" }}
                                                                    />{" "}
                                                                    <span className="w-space-no">{`${element.first_name_chr ? element.first_name_chr : "-"} ${element.last_name_chr ? element.last_name_chr : ""}`}</span>
                                                                </div>
                                                            </td> */}

                                                            {/* <td>
                                                                <span>{`${element?.meta_data?.description ? element?.meta_data?.description : "-"}`}</span>
                                                            </td> */}





                                                            <td>
                                                                <span className="">{`${USDollar.format(element?.meta_data?.amount ? (element?.meta_data?.amount / 100) : 0)}`}</span>
                                                            </td>

                                                            <td>
                                                                <span
                                                                    className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                    style={{
                                                                        background: "rgba(79, 93, 116, 1)",
                                                                    }}>
                                                                    {`${element?.status_chr ? element?.status_chr : "-"}`}
                                                                </span>
                                                            </td>

                                                            {/* <td>
                                                                <div
                                                                    onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        if (element?.user_id_ids === isExpandedTransactionId) {
                                                                            setIsExpandedTransactionId('')
                                                                        } else {
                                                                            setIsExpandedTransactionId(element.user_id_ids)
                                                                        }
                                                                    }}
                                                                    className="d-flex align-items-center justify-content-center bg-light rounded-3 overlay-action-btn text-black"
                                                                    style={{ fontSize: '15px', height: '30px', width: '35px' }}>
                                                                    {element?.user_id_ids === isExpandedTransactionId ? <i class="bi bi-chevron-down"></i> : <i class="bi bi-chevron-right"></i>}
                                                                </div>
                                                            </td> */}
                                                        </tr>

                                                        <tr>
                                                            <td colSpan="8" className={`bg-light ${(element?.call_log_transactions_id_ids !== isExpandedTransactionId) ? 'p-0' : ''}`}>
                                                                <Collapse
                                                                    in={element?.call_log_transactions_id_ids === isExpandedTransactionId}
                                                                >
                                                                    <div className='row mx-0'>
                                                                        <div className='col-12 px-0'>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Full name`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="">{`${element.first_name_chr ? element.first_name_chr : "-"} ${element.last_name_chr ? element.last_name_chr : ""}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Email`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="" >{element.email_chr ? element.email_chr : "-"}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Phone`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="" >{element.phone_number_int == null ? ('-') : <InternationalPhoneFormat countryCode={element.country_phone_code_chr} phoneNumber={`${element.phone_number_int}`} />}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Created on`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="">{`${element?.created_date_dtm ? formatUnixTimestamp(element?.created_date_dtm) : '-'}`}</span>
                                                                                </div>
                                                                            </div>

                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Last login`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className="">{`${element?.last_log_in_dtm ? formatUnixTimestamp(element?.last_log_in_dtm) : '-'}`}</span>
                                                                                </div>
                                                                            </div>



                                                                            <div className='row mx-0 py-1 fs-6'>
                                                                                <div className='col-4 px-0 '>
                                                                                    <span className="text-black font-w600">{`Status`}</span>
                                                                                </div>
                                                                                <div className='col-8 px-0 '>
                                                                                    <span className=" font-w600" style={{ color: element?.is_verified_ysn ? "rgba(45, 204, 99, 1)" : "rgba(255, 0, 0, 1)" }}>{element?.is_verified_ysn ? `Verified` : `Unverified`}</span>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </Collapse>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            })}</> :
                                        <tr>
                                            <td colSpan="4">No Records Found</td>
                                        </tr>
                                    }
                                </>
                            }
                        </tbody>
                    </Table>
                </div>
            </div>


            {handleToaster && (
                <ResponceToaster toasterType={toasterType} message={resMessage} />
            )}
        </>
    );
};

export default TransactionsForAdmin;



